const returnOpacity = (value) => {
  var valueInt = parseInt(value, 10);
  if (value === '100') {
    return '1.0';
  } else {
    return `0.${valueInt}`;
  }
};

export default returnOpacity;


// WEBPACK FOOTER //
// ./src/scripts/return-opacity.js